'use client';
import MarqueeCarousel from '@c/MarqueeCarousel';
import SafeImage from '@ui/SafeImage';
import { prefix } from '@util/imagePrefix';
import { Star } from 'lucide-react';

export type Testimonial = {
  name: string;
  location: string;
  quote: string;
  avatar: string;
};

const avatarAsset = (fileName: string) =>
  `${prefix}/assets/what-is-mx-locker/${fileName}_1920x2560.webp`;

export const testimonials: Testimonial[] = [
  {
    name: 'Brett Gavaza',
    location: 'United States',
    quote:
      'Item showed up the next day after ordering. Item was exactly the same as listing. Seamless process. Highly recommend.',
    avatar: avatarAsset('avatar-brett-gavaza_1920x2560'),
  },
  {
    name: 'Josh Hamby',
    location: 'United States',
    quote:
      "I've bought a few items for my moto collection and all items came fast and as description mentioned them, never had an issue. Fast, honest and reliable. I'll continue to do business with MX Locker.",
    avatar: avatarAsset('avatar-josh-hamby_1920x2560'),
  },
  {
    name: 'Andrew Whiteside',
    location: 'United States',
    quote:
      "Have used the app to source many parts at a discounted price. All sellers have been quick, sending things as described. Love using the app because it's motorcycle specific.",
    avatar: avatarAsset('avatar-andrew-whiteside_1920x2560'),
  },
  {
    name: 'Logan Morcom',
    location: 'United States',
    quote:
      'Best app created for motocross marketplace. The app is easy to use and you can find super good deals on great parts.',
    avatar: avatarAsset('avatar-default_1920x2560'),
  },
  {
    name: 'Brandon Kone',
    location: 'United States',
    quote:
      'Best place for niche parts. Quick, cheap, trustworthy. Love MX Locker.',
    avatar: avatarAsset('avatar-brandon-kone_1920x2560'),
  },
  {
    name: 'Chance Lettner',
    location: 'United States',
    quote:
      'I bought a tune up kit for my 01 ZX-6R and it came with everything it stated and it was packed well. All of the parts are genuine Kawasaki parts without the extra costs. The shipping was quick too.',
    avatar: avatarAsset('avatar-chance-lettner_1920x2560'),
  },
  {
    name: 'Kirkwood',
    location: 'United States',
    quote:
      'MX Locker is a great place to pick up new and used parts. Definitely recommend if you need anything moto related.',
    avatar: avatarAsset('avatar-kirkwood_1920x2560'),
  },
  {
    name: 'Todd Jones',
    location: 'United States',
    quote:
      'Team at MX Locker have been great to deal with. First class operation.',
    avatar: avatarAsset('avatar-default_1920x2560'),
  },
  {
    name: 'Cooper McClure',
    location: 'United States',
    quote:
      'Great with shipping, super cheap for brand new boots, this website is the way to go.',
    avatar: avatarAsset('avatar-cooper-mcclure_1920x2560'),
  },
  {
    name: 'H T',
    location: 'United States',
    quote:
      "Ordered and had fast and quality shipping. Prices weren't over the top and the item was in good condition. 100% recommend for anyone in need of anything in the powersports genre.",
    avatar: avatarAsset('avatar-h-t_1920x2560'),
  },
];

export const TestimonialCard = ({
  testimonial,
}: {
  testimonial: Testimonial;
}) => (
  <div className="flex w-[40.5rem] shrink-0 snap-center flex-col gap-[2rem] rounded-[2rem] bg-white p-[2rem]">
    <div className="flex gap-[1.25rem]">
      <SafeImage
        src={testimonial.avatar}
        alt={testimonial.name}
        className="h-[6rem] w-[6rem] rounded-full"
      />
      <div className="flex flex-col justify-center text-[1.75rem] leading-[1.5]">
        <span className="font-bold text-black">{testimonial.name}</span>
        <span className="font-medium text-[#444444]">
          {testimonial.location}
        </span>
      </div>
    </div>
    <div className="flex flex-col gap-[1rem]">
      <div className="flex gap-[0.5rem]">
        {Array.from({ length: 5 }, (_, i) => (
          <Star
            key={i}
            className="h-[3rem] w-[3rem] fill-brand-secondary text-brand-secondary"
          />
        ))}
      </div>
      <p className="text-[1.75rem] font-medium leading-[1.5] text-[#444444]">
        {testimonial.quote}
      </p>
    </div>
  </div>
);

const TestimonialsMarquee = ({
  items = testimonials,
  fadeClassName = 'from-light-grey',
}: {
  items?: Testimonial[];
  /** `from-*` color matching the section background. */
  fadeClassName?: string;
}) => (
  <MarqueeCarousel
    items={items}
    renderItem={(testimonial) => <TestimonialCard testimonial={testimonial} />}
    contentClassName="gap-[2rem] px-[2rem]"
    fadeClassName={fadeClassName}
    dotClassName="bg-black"
  />
);

export default TestimonialsMarquee;
